/**
 * Возвращает единицу измерения в правильном склонении.
 * Применимо для целых чисел.
 * @param {number} number Число.
 * @param {string[]} words Массив склонений в формате [1, 3, 5].
 * @return {string}
 */
export function decline(number, words) {
    number = Math.abs(number) % 100;
    if (number >= 11 && number <= 19) {
        return words[2];
    } else {
        switch (number % 10) {
            case 1:
                return words[0];
            case 2:
            case 3:
            case 4:
                return words[1];
            default:
                return words[2];
        }
    }
}


/**
 * Возвращает true если в array содержится хотя бы один элемент из value и false, если не содержится или array не определен.
 * @param {array} array Массив.
 * @param {aaray} value Массив. Необязательный параметр. Если не указан - проверка на то что array не пуст.
 * @return {boolean}
 */
export function arrayContainsValue(array, value) {
    if (value) {
        if (array) {
            for (var i=0; i<array.length; i++) {
                for (var j=0; j<value.length; j++) {
                    if (array[i] === value[j]) {
                        return true;
                    }
                }
            }
        }
        return false;
    } else {
        return (array ? array.length > 0 : false);
    }
}

export function owox() {
    (function(){function g(h,b){var f=h.get('sendHitTask'),g=function(){function a(a,e){var d='XDomainRequest'in window?'XDomainRequest':'XMLHttpRequest',c=new window[d];c.open('POST',a,!0);c.onprogress=function(){};c.ontimeout=function(){};c.onerror=function(){};c.onload=function(){};c.setRequestHeader&&c.setRequestHeader('Content-Type','text/plain');'XDomainRequest'==d?setTimeout(function(){c.send(e)},0):c.send(e)}function f(a,e){var d=new Image;d.onload=function(){};d.src=a+'?'+e}var g=b&&b.domain?b.domain:'google-analytics.bi.owox.com';return{send:function(b){var e=location.protocol+'//'+g+'/collect',d;try{navigator.sendBeacon&&navigator.sendBeacon(d=e+'?tid='+h.get('trackingId'),b)||(2036<b.length?a(d?d:e+'?tid='+h.get('trackingId'),b):f(e,b))}catch(c){}}}}();h.set('sendHitTask',function(a){if(b&&0<b.sessionIdDimension)try{a.set('dimension'+b.sessionIdDimension,a.get('clientId')+'_'+Date.now()),a.get('buildHitTask')(a)}catch(h){}f(a);g.send(a.get('hitPayload'))})}var f=window[window.GoogleAnalyticsObject||'ga'];'function'==typeof f&&f('provide','OWOXBIStreaming',g)})();
}

export function cancelablePromise(promise) {
    let hasCanceled_ = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then((val) =>
            hasCanceled_ ? reject({isCanceled: true}) : resolve(val)
        );
        promise.catch((error) =>
            hasCanceled_ ? reject({isCanceled: true}) : reject(error)
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled_ = true;
        },
    };
}

/**
 * Set correct endings for nouns near numbers
 */
export const russianEndingsForm = (n, form1, form2, form5) => {
    n  = Math.abs(n) % 100
    const n1 = n % 10
    
    if (n > 10 && n < 20) {
        return form5
    }
    if (n1 > 1 && n1 < 5) {
        return form2
    }
    
    if (n1 == 1) {
        return form1
    }
    
    return form5
}



// WEBPACK FOOTER //
// ./client/core/utils.js